import React from "react";
import { Box, Typography, CardMedia } from "@mui/material";
import AboutImage from "../Assets/AboutImage.png";

const AboutPage = () => {
  return (
    <Box
      sx={{
        minHeight: "85vh",
        mt: "10vh", 
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: { xs: 2, sm: 4, md: 0 },
      }}
    >
      {/* MAIN GREEN CONTAINER */}
      <Box
        sx={{
          bgcolor: "#1E412D",
          color: "#F5EDE3",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          borderRadius: { xs: 0, md: "12px" },
          textAlign: "justify",
          boxSizing: "border-box",
          px: { xs: "10px", sm: "20px", md: "80px" },
          py: { xs: 5, sm: 7, md: 10 },
          mt: "30px",

          // ✅ Balanced spacing both sides — same feel as Home Page
          mx: { xs: 0, md: "100px" },
          width: { xs: "100%", sm: "100%", md: "calc(100% - 200px)" },

          // ✅ Laptop & desktop adjustments matching Home layout
          "@media (min-width:1024px) and (max-width:1280px)": {
            mx: "50px",
            px: "50px",
            py: 7,
            width: "calc(100% - 100px)",
          },
          "@media (min-width:1281px) and (max-width:1440px)": {
            mx: "60px",
            px: "70px",
            py: 8,
            width: "calc(100% - 120px)",
          },
          "@media (min-width:1441px)": {
            mx: "80px",
            px: "90px",
            py: 10,
            width: "calc(100% - 160px)",
          },
        }}
      >
        {/* HEADING */}
        <Typography
          variant="h3"
          sx={{
            fontFamily: "Playfair Display, serif",
            fontWeight: 700,
            textAlign: "center",
            mb: 4,
            color: "#F5EDE3",
            fontSize: {
              xs: "2rem",
              sm: "3rem",
              md: "3.8rem",
              lg: "4rem",
            },
            lineHeight: 1.2,
          }}
        >
          About Us
        </Typography>

        {/* BODY CONTENT */}
        <Typography
          variant="body1"
          sx={{
            fontFamily: "Lora, serif",
            color: "#F5EDE3",
            fontSize: {
              xs: "0.95rem",
              sm: "1rem",
              md: "1.2rem",
              lg: "1.3rem",
            },
            lineHeight: 1.8,
          }}
        >
          <strong>The Blush Story by Aarti Soni</strong> is a Nagpur-based makeup
          brand born from passion, creativity, and a deep love for beauty.
          Founded by <strong>Aarti Soni Dhanak</strong>, a certified professional makeup
          artist, the brand is known for its elegant style, personalized artistry,
          and dedication to enhancing natural beauty.
        </Typography>

        {/* INLINE IMAGE */}
        <CardMedia
          component="img"
          image={AboutImage}
          alt="Aarti Soni — Founder"
          sx={{
            width: { xs: "100%", sm: "90%", md: "85%", lg: "80%" },
            height: "auto",
            objectFit: "contain",
            borderRadius: 0,
            my: { xs: 2, sm: 3, md: 4 },
            mx: "auto",
            display: "block",
          }}
        />

        <Typography
          variant="body1"
          sx={{
            fontFamily: "Lora, serif",
            color: "#F5EDE3",
            fontSize: {
              xs: "0.95rem",
              sm: "1rem",
              md: "1.2rem",
              lg: "1.3rem",
            },
            lineHeight: 1.8,
            mt: { xs: 0, sm: 1, md: 1 },
          }}
        >
          Aarti’s journey began with a dream — to make every woman feel beautiful
          in her own skin. In 2025, she completed her professional makeup course
          at <strong>Prachi’s Makeover Academy</strong> in Nagpur, under the
          guidance of an <strong>international makeup mentor</strong>. Her
          expertise includes styles such as <strong>party, engagement, bridal,</strong>{" "}
          and <strong>reception makeup</strong>, along with diverse{" "}
          <strong>hairstyles</strong> and <strong>saree draping</strong>{" "}
          techniques.
          <br />
          <br />
          At The Blush Story, every look is a reflection of elegance and
          individuality — because beauty isn’t about transformation, it’s about
          celebrating who you truly are.
        </Typography>
      </Box>
    </Box>
  );
};

export default AboutPage;
